export const LanguageEnum = {
  lookupTypeId: 114,
};
